const { html, url, routes } = window;

export default (alternativeButtonText) => `
    <div class='message-container'>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.sorry')}</p>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.contactSupportHtml',
            {link: `<a target="_blank" class="u-lowercase" href="${url(routes.supportMembers)}">${html('contactSupport')}</a>`})}
        </p>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.forNowUseReadHtml', {option: `
            <span style='font-weight: bold'>${alternativeButtonText}</span>
        `})}</p>
    </div>
    <div class='button-container'>
        <button type='button' class='confirm-button button radius secondary contrast u-allCaps u-center'>${html('ok')}</button>
    </div>
`;
